import React, { useEffect } from 'react'
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { FiSettings } from 'react-icons/fi';
import { useStateContext } from '../contexts/ContextProvider';
import { Navbar, Notification, Sidebar, ThemeSettings } from '../components';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosClient from '../axios-client';
import Sidebar2 from '../components/Sidebar2';

const DefaultLayout = () => {
  const getUser = () => {
    axiosClient.get('/user')
      .then((response) => {

        setUser(response.data.user);
      }).catch(error => {
        setToken(null);
        localStorage.removeItem('ACCESS_TOKEN');
        navigate('/login');

      })
  }
  useEffect(() => {
    getUser();
  }, []);
  const { activeMenu, themeSettings, setThemeSettings,
    currentColor, token, user, setUser, setToken } = useStateContext();

  const navigate = useNavigate();


  if (!token) {
    return <Navigate to="/login" />
  }




  return (
    <div
      translate="no"
      className="flex relative dark:bg-gray-900 bg-gray-50 animate-fade-in-down transition-colors duration-300"
    >
      {/* Settings button - uncomment if needed */}
      {/* <div className="fixed right-4 bottom-4" style={{ zIndex: 1000 }}>
        <TooltipComponent content="Settings" position="top">
          <button 
            type="button" 
            className="text-3xl p-3 hover:drop-shadow-2xl hover:bg-gray-100 text-white transition-all duration-200 rounded-full"
            onClick={() => setThemeSettings(true)}
            style={{
              background: `${currentColor}`,
            }}
          >
            <FiSettings className="transition-transform duration-200 hover:scale-110" />
          </button>
        </TooltipComponent>
      </div> */}

      {/* Sidebar */}
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-gray-800 bg-white h-screen shadow-lg border-r border-gray-200 dark:border-gray-700 transition-all duration-300">
          <Sidebar2 />
        </div>
      ) : (
        <div className="w-0 fixed sidebar dark:bg-gray-800 bg-white transition-all duration-300">
        </div>
      )}

      {/* Main content area */}
      <div className={`dark:bg-gray-900 bg-gray-50 min-h-screen w-full transition-all duration-300 ${activeMenu ? 'md:ml-72' : 'flex-1'
        }`}>

        {/* Navbar */}
        <div className="fixed md:static bg-white dark:bg-gray-800 navbar w-full shadow-sm dark:shadow-gray-900/50 border-b border-gray-200 dark:border-gray-700 z-40">
          <Navbar />
        </div>

        {/* Theme Settings */}
        <div className="relative z-30">
          {themeSettings && <ThemeSettings />}
        </div>

        {/* Main content */}
        <div className="flex min-h-screen flex-col justify-between">
          <div className="m-2 mt-12 max-h-screen h-auto overflow-auto lg:m-3 xl:m-3 md:m-10 md:mt-12 p-4 md:p-10 bg-white dark:bg-gray-800 shadow-xl rounded-2xl border border-gray-200 dark:border-gray-700 transition-all duration-300">
            <Notification />
            <Outlet />
            <ToastContainer />

          </div>
          <div className="flex m-2 items-center justify-center mt-3 max-h-screen h-auto overflow-auto lg:m-3 xl:m-3 md:m-7   bg-white dark:bg-gray-800 shadow-xl rounded-md border border-gray-200 dark:border-gray-700 transition-all duration-300 ">
            <footer className=" bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-4 px-6 text-center text-gray-600 dark:text-gray-300 transition-colors duration-200">
              <a
                href="https://www.rimlog.net"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                aria-label="Visit Rimlog website"
              >
                <span>Supported by Rimlog</span>
                <div className="w-8 h-8">
                  <img
                    src="https://rimlog.net/assets/img/logo.png"
                    alt="Rimlog logo"
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      e.target.style.display = 'none'; // Hide broken image
                      e.target.nextSibling.style.display = 'flex'; // Show fallback icon
                    }}
                  />

                </div>
              </a>
            </footer>
          </div>
          {/* Footer */}

        </div>
      </div>

    </div>
  )
}

export default DefaultLayout